import { context } from "../../components/wr-context";
var proposalsItemsAvailable = function() {
    var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var catalogs = context.state.catalogs;
    items = items.filter(function(item) {
        var itemsInCatalog = [];
        catalogs.forEach(function(catalog) {
            var ref;
            var itemFound = catalog === null || catalog === void 0 ? void 0 : (ref = catalog.contents) === null || ref === void 0 ? void 0 : ref.items.find(function(catalogItem) {
                return catalogItem.id === item;
            });
            if (itemFound) {
                itemsInCatalog.push(item);
            }
        });
        if (itemsInCatalog.length) return item;
    });
    return items.length;
};
export default {
    proposalsItemsAvailable: proposalsItemsAvailable
};
